import { ApiServiceTypes } from '@pascal/pascal-core/shared/core/enums/ApiServiceTypes';

export const ApiServiceNames = {
  ...ApiServiceTypes,
  BonusIslandService: 'bonusIslandService',
};
